import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink } from 'reactstrap';
import ReCAPTCHA from "react-google-recaptcha";

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

import Api from '../../../api'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      pwd: '',
      evt: '',
    }
  }

  login(e) {
    e.preventDefault()

    if(this.state.evt.length == 0) {
      alert("You must solve the CAPTCHA in order to log in.");
    } else {
      var api = new Api()
      // api.login('goldmoz@gmail.com', '123456', (succ, user) => {
      api.login(this.state.email, this.state.pwd, (succ, user) => {
        if(succ) {
          const params = new URLSearchParams(this.props.location.search);
          if(params.get("client_id") == "7182771477656bec39a6ff13f835fbaf") {
            api.addToken(this.state.email, (succ, dat) => {
              // console.log(succ + " " + JSON.stringify(dat));
              if(succ) {
                window.location = decodeURIComponent(params.get("redirect_uri"))+"#state="+params.get("state")+"&access_token="+dat["Attributes"]["token"]+"&token_type=Bearer";
              }
            });
          } else {
            api.mount(user['email']);
            if(this.state.pwd.startsWith("amc_")) {
              api.jump('changepw');
            } else {
              api.jump('list');
            }
          }
        } else {
          alert("The email address or password you entered is incorrect Please try again.");
        }
      })
    }
  }

  render() {
    const params = new URLSearchParams(this.props.location.search);
    return (
      <div className="app align-items-center mcg">
        <span className="frontbk" style={{zIndex:"0"}} />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
              <Card className="mb-0" style={{width: "100%"}}>
              { params.get("client_id") == null && <Menu/> }
                <CardHeader className="sihead">
                  <h1>User Login</h1>
                  <p className="text-center mb-0">
                    If you already have a MyCaregiver account please login or just click the 
                    <NavLink href="/register" style={{padding:'0', display:'inline'}}> Register Button or Here </NavLink>
                    to create one.
                  </p>
                </CardHeader>
                <CardBody className="login-form text-center logbox">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-user" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="text" placeholder="Email" autoComplete="email" onChange={(evt) => { this.setState({email: evt.target.value}); }}/>
                  </InputGroup>
                  <div className="wraning-msg">
                    {/* Warning message for LoginID */}
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="password" placeholder="Password" autoComplete="current-password" onChange={(evt) => { this.setState({pwd: evt.target.value}); }}/>
                  </InputGroup>
                  <div className="wraning-msg">
                    {/* Warning message for LoginID */}
                  </div>
                  <ReCAPTCHA
                    sitekey={window.location.hostname=="localhost"?"6LfWHY4UAAAAAELOAHAlvX4_O_Vm9VD-DAQ4KOkL":"6Ldz15MUAAAAACOwuo8Tuz0AhX5hfh_gzPWD339l"}
                    onChange={(evt) => {
                      this.setState({evt: evt});
                    }}
                  />
                  <div className="wraning-msg">
                    {/* Warning message for Password */}
                  </div>
                  {/*
                    <p>
                    <NavLink href="/forgetpw" style={{ padding: '0', display: 'inline' }}>Forget Password?</NavLink>
                  </p>
                  */}
                  <Row>
                    <Col>
                      {/* <NavLink href="/setting"><Button color="primary" className="px-4 btn-brand">Log-in</Button></NavLink> */}
                      <Button color="primary" className="px-4 btn-brand" onClick={this.login.bind(this)}>Log-in</Button><br/>
                    </Col>
                    <Col>
                      <NavLink href="/forgetpw" ><Button outline  className="px-4 btn-outline" color="primary">Forget Password</Button></NavLink>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"2"}}>
          <CRNote/>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js